/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { HealthService } from './services/health.service';
import { PdiDkvApiService } from './services/pdi-dkv-api.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    HealthService,
    PdiDkvApiService,
    ApiConfiguration
  ],
})
export class PdiDkvApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<PdiDkvApiModule> {
    return {
      ngModule: PdiDkvApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: PdiDkvApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('PdiDkvApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
